export default "__VITE_ASSET__BBdQqQVd__"